var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhotos = function SvgPhotos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M14.25 3.101v17M5.25 11.101h17M.75.601h26v23h-26z"
  })));
};
export default SvgPhotos;